import { API_URL } from '../config/api';

/**
 * Converts a relative image URL to a full URL
 * Handles both old format (/api/media/files/...) and new format (/media/files/...)
 * Also handles full URLs (http/https) and returns them as-is
 * 
 * This function ensures images work correctly in both localhost and production environments
 */
export const getFullImageUrl = (url) => {
  if (!url) return '';
  
  // If it's already a full URL, return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // Normalize API_URL to ensure it doesn't have trailing slash
  const baseUrl = API_URL.endsWith('/') ? API_URL.slice(0, -1) : API_URL;
  
  // Handle old format: /api/media/files/filename
  if (url.startsWith('/api/media/files/')) {
    // Remove /api prefix from url since API_URL already includes /api
    const filename = url.replace('/api/media/files/', '');
    return `${baseUrl}/media/files/${filename}`;
  }
  
  // Handle new format: /media/files/filename
  // This is the format stored by the media gallery
  if (url.startsWith('/media/files/')) {
    // API_URL is like http://127.0.0.1:5000/api or https://slenet.dev/api
    // url is like /media/files/filename
    // Result: http://127.0.0.1:5000/api/media/files/filename or https://slenet.dev/api/media/files/filename
    return `${baseUrl}${url}`;
  }
  
  // Handle /media/ prefix (without /files/)
  if (url.startsWith('/media/')) {
    return `${baseUrl}${url}`;
  }
  
  // If it doesn't start with /, assume it's a relative path and prepend /media/files
  // This handles cases where the URL might be just the filename
  if (!url.startsWith('/')) {
    return `${baseUrl}/media/files/${url}`;
  }
  
  // Handle /api/ prefix (legacy format)
  if (url.startsWith('/api/')) {
    // Remove /api prefix and prepend baseUrl
    const pathWithoutApi = url.replace('/api', '');
    return `${baseUrl}${pathWithoutApi}`;
  }
  
  // Default: prepend API_URL for any other relative paths
  return `${baseUrl}${url}`;
};
